import React from 'react';
import { FunctionFactory } from 'survey-core';
import { ProteinTracking } from '../quiz/protein';

const proteinSplashHtml = `
<div class="new-quote-container centered">
  <div class="splash-icon">{proteinIcon}</div>
  <div class="splash-header">
    <h1>{proteinTitle}</h1>
    <div class="quote">
      {proteinQuote}
    </div>
  </div>
</div> 
`;

const proteinSplashExpression = {
  name: "proteinQuote",
  expression: "renderProteinQuote({protein})",
};

function renderProteinQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as ProteinTracking) {
    case ProteinTracking.NoIdea:
      return `Most people have never tracked protein intake. We’ll show you how to start hitting your protein target with ease.`;
    case ProteinTracking.EatingMore:
    case ProteinTracking.PrettyClose:
      return `We’ll show you how to continue hitting your protein target with ease, and ensure you’re eating the highest quality protein sources.`;

    case ProteinTracking.EatingLess:
      return `Most people aren’t eating enough protein. We’ll show you how to start hitting your protein target with ease.`;
  }
}

FunctionFactory.Instance.register("renderProteinQuote", renderProteinQuote);

const proteinSplashElement = {
  name: 'protein-splash',
  type: 'html',
  html: proteinSplashHtml,
}

function renderProteinTitle(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as ProteinTracking) {
    case ProteinTracking.NoIdea:
      return "No worries, <div class='highlight'><span>{name}</span>.</div>";
    case ProteinTracking.EatingMore:
    case ProteinTracking.PrettyClose:
      return "You’re one step ahead, <div class='highlight'><span>{name}</span>.</div>";
    case ProteinTracking.EatingLess:
      return "No worries, <div class='highlight'><span>{name}</span>.</div>";
  }
}

FunctionFactory.Instance.register("renderProteinTitle", renderProteinTitle);

const proteinSplashTitleExpression = {
  name: "proteinTitle",
  expression: "renderProteinTitle({protein})",
};

function renderProteinIcon(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as ProteinTracking) {
    case ProteinTracking.NoIdea:
      return "🍳";
    case ProteinTracking.EatingMore:
    case ProteinTracking.PrettyClose:
      return "🏅";
    case ProteinTracking.EatingLess:
      return "🪄";
  }
}

FunctionFactory.Instance.register("renderProteinIcon", renderProteinIcon);

const proteinSplashIconExpression = {
  name: "proteinIcon",
  expression: "renderProteinIcon({protein})",
};

const ProteinSplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A", 
      fontSize: "12px",
    }}>
      🥩 Nailing the basics
    </div>
  )
}
export {
  proteinSplashElement,
  proteinSplashExpression,
  ProteinSplashHeader,
  proteinSplashTitleExpression,
  proteinSplashIconExpression,
}
